import { string } from "prop-types";
import React, { Fragment } from "react";
import * as style from "./styles.module.scss";

const HorizontalLine = ({ text = "", desc = "" }) => {
  return (
    <div>
      <span className="w-100 d-flex align-items-center">
        {text && (
          <Fragment>
            <span
              className={`${style.horizontalline__line} ${style.horizontalline__first}`}
            ></span>
            <span className={style.horizontalline__text}>{text}</span>
            <span
              className={`${style.horizontalline__line} ${style.horizontalline__last}`}
            ></span>
          </Fragment>
        )}
      </span>
      {desc && <p className={style.horizontalline__subtext}>{desc}</p>}
    </div>
  );
};

HorizontalLine.propTypes = {
  text: string,
  desc: string,
};

export default HorizontalLine;
